<template>
  <div v-show="isShow.isPOShow" class="pageOne">
    <div id="music" class="music" @click="toggleMusic">
      <div class="cloud">
        <div class="note on" :class="isPlay ? 'rotating' : 'off'"></div>
      </div>
      <audio :src="musicURL" id="s07" preload="preload" loop ></audio>
    </div>

    <video
      class="myVideo"
      ref="myVideo"
      preload="auto"
      playsinline="true"
      webkit-playsinline="true"
      x5-video-player-type="h5"
      x5-video-orientation="portrait"
      poster="./pos.jpg"
    >
      <source :src="videoURL" type="video/mp4">
    </video>
    <div class="md1 md" :class="isMd1Show ? 'slideIn' : ''" v-show="isMd1Show"></div>
    <div class="md2 md" :class="isMd2Show ? 'slideIn' : ''" v-show="isMd2Show"></div>
    <div class="btn-main" @click="onClickMain" :class="isMainShow ? 'slideIn' : ''" v-show="isMainShow"></div>
    <div class="vd-btn-group" v-show="isGroupShow" :class="isGroupShow ? 'slideIn' : ''">
      <div class="vd-btn" @click="onClickLeft" :class="calcScene.left"></div>
      <div class="vd-btn" @click="onClickRight" :class="calcScene.right"></div>
    </div>
    <toast :isToast="toastShow" :myScene="scene" @sendCrossIt="onSendCrossIt" />
    <audio :src="m001URL" id="s01" preload="preload"></audio>
    <audio :src="m002URL" id="s02" preload="preload"></audio>
    <audio :src="m003URL" id="s03" preload="preload"></audio>
    <audio :src="m004URL" id="s04" preload="preload"></audio>
    <audio :src="m005URL" id="s05" preload="preload"></audio>
    <audio :src="m006URL" id="s06" preload="preload"></audio>

  </div>
</template>

<script>
import Toast from '../../components/toast/toast';

export default {
  name: 'PageOne',
  props: {
    isShow: {
      type: Object
    },
    myAniFlag: {
      type: Boolean
    }
  },
  data () {
    return {
      isMd1Show: false,
      isMd2Show: false,
      isGroupShow: false,
      isMainShow: false,
      toastShow: false,
      scene: 1,
      videoURL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/mp4/6.mp4',
      m001URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/wave.mp3',
      m002URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/lightning.mp3',
      m003URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/walk.mp3',
      m004URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/birds.mp3',
      m005URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/machine.mp3',
      m006URL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/btn.mp3',
      musicURL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/bgm.mp3',
      isPlay: true
    }
  },
  computed: {
    calcScene () {
      switch (this.scene) {
        case 1:
          return {
            left: 'btn11',
            right: 'btn12'
          }
        case 2:
          return {
            left: 'btn21',
            right: 'btn22'
          }
        case 3:
          return {
            left: 'btn31',
            right: 'btn32'
          }
        case 4:
          return {
            left: 'btn41',
            right: 'btn42'
          }
        default:
          return {
            left: 'btn11',
            right: 'btn12'
          }
      }
    }
  },
  components: {
    Toast
  },
  methods: {
    toggleMusic () {
      if (this.isPlay) {
        this.audioPause();
        this._playVideo();
      } else {
        this.audioPlay();
        this._playVideo();
      }
      this.isPlay = !this.isPlay
    },
    audioPlay () {
      let audio = document.getElementById('s07');
      const _this = this;
      audio.play();
      // this._playVideo();
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play();
        // _this._playVideo();
      }, false)
    },
    audioPause () {
      let audio = document.getElementById('s07')
      audio.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.pause()
      }, false)
    },

    _initMusic (id) {
      let audio = document.getElementById(id);
      // audio.volume = 0
      audio.play();
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play();
      }, false);

      setTimeout(() => {
        audio.pause();
        document.addEventListener('WeixinJSBridgeReady', function () {
          audio.pause();
        }, false);
      }, 20);
    },
    _initAllMusic () {
      for (let i = 1; i < 8; i++) {
        let myId = `s0${i}`;
        this._initMusic(myId);
      }
    },
    svPlay (data) {
      let musicName = data.name;
      const _this = this;
      let audio = document.getElementById(musicName);
      audio.play();
      this._playVideo();
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play();
        _this._playVideo();
      }, false);
    },

    onSendCrossIt (msg) {
      this.toastShow = false;
      this.isGroupShow = false;
      const getNum = msg.sNum;
      this.calcPlay(getNum);
    },
    showNext () {
      this.isShow.isPIShow = true;
      this.isShow.isPOShow = false;
    },
    _playVideo () {
      const videoEle = this.$refs.myVideo;
      videoEle.play();
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.play();
      }, false);
    },
    _pauseVideo () {
      const videoEle = this.$refs.myVideo;
      videoEle.pause();
      document.addEventListener('WeixinJSBridgeReady', function () {
        videoEle.pause();
      }, false);
    },
    onClickMain () {
      this.isMainShow = false;
      this._playVideo();
      // this.$emit('hvDirective', {name: 'm06'});
      this.svPlay({name: 's06'});
      this.audioPlay();
    },
    onClickRight () {
      this.toastShow = true;
      // this.$emit('hvDirective', {name: 'm06'});
      this.svPlay({name: 's06'});
    },
    calcPlay (num) {
      const videoEle = this.$refs.myVideo;
      this._pauseVideo();
      switch (num) {
        case 1:
          videoEle.currentTime = 19;
          this._playVideo();
          this.scene = 2;
          break;
        case 2:
          videoEle.currentTime = 39;
          this._playVideo();
          this.scene = 3;
          break;
        case 3:
          videoEle.currentTime = 64;
          this._playVideo();
          this.scene = 4;
          break;
        case 4:
          videoEle.currentTime = 80;
          this._playVideo();
          // this.scene = 2;
          break;
        default:
          this._playVideo();
          break;
      }
    },
    onClickLeft () {
      // this.$emit('hvDirective', {name: 'm06'});
      this.svPlay({name: 's06'});
      this.isGroupShow = false;
      this.calcPlay(this.scene);
    }
  },
  watch: {
    myAniFlag () {
      setTimeout(() => {
        this.isMd1Show = true;
      }, 400);
      setTimeout(() => {
        this.isMd1Show = false;
        this.isMd2Show = true;
      }, 3400)
      setTimeout(() => {
        this.isMd2Show = false;
        this.isMainShow = true;
      }, 6400);
    }
  },
  mounted () {
    const videoEle = this.$refs.myVideo;
    const _this = this;
    document.addEventListener("WeixinJSBridgeReady", function () {
      videoEle.play();
      videoEle.pause();
    }, false);

    videoEle.addEventListener('timeupdate', function (evt) {
      let curTime = videoEle.currentTime;
      console.log(_this.scene)
      const condition1 = (curTime > 7 && curTime < 8 && _this.scene==1) || (curTime > 27 && curTime < 28 && _this.scene==2) || (curTime > 52 && curTime < 53 && _this.scene==3) || (curTime > 68 && curTime < 69 && _this.scene==4);
      const condition2 = (curTime > 18 && curTime < 19) || (curTime > 38 && curTime < 39) || (curTime > 63 && curTime < 64) || (curTime > 79 && curTime < 80);
      if (condition1) {
          _this.isGroupShow = true;
      }
      if (curTime > 18 && curTime < 19) {
        if(_this.scene==1){
          videoEle.currentTime = 8;
        }
      } else if (curTime > 38 && curTime < 39) {
        if(_this.scene==2){
          videoEle.currentTime = 28;
        }
      } else if (curTime > 63 && curTime < 64) {
        if(_this.scene==3){
          videoEle.currentTime = 53;
        }
      } else if (curTime > 77 && curTime < 78) {
        if(_this.scene==4){
          videoEle.currentTime = 69;
        }
      }

      if (curTime > 3 && curTime < 4) {
        // _this.$emit('hvDirective', {name: 'm01'})
        _this.svPlay({name: 's01'});
      }

      if (curTime > 15 && curTime < 16) {
        _this.svPlay({name: 's07'});
      }

      if (curTime > 7 && curTime < 8) {
        // _this.$emit('hvDirective', {name: 'm02'})
        _this.svPlay({name: 's02'});
      }

      if (curTime > 46 && curTime < 47) {
        // _this.$emit('hvDirective', {name: 'm03'})
        _this.svPlay({name: 's03'});
      }

      if (curTime >50  && curTime < 51) {
        // _this.$emit('hvDirective', {name: 'm04'})
        _this.svPlay({name: 's04'});
      }

      if (curTime > 84 && curTime < 85) {
        // _this.$emit('hvDirective', {name: 'm05'})
        _this.svPlay({name: 's05'});
      }

      if (curTime > 89 && curTime < 90) {
        // _this.$emit('hvDirective', {name: 'm05'})
        _this.svPlay({name: 's05'});
      }

      // if (curTime > 98 && curTime < 99) {
      //   _this.showNext();
      // }
      //console.log('curTime: ', curTime);
    })

    videoEle.addEventListener('ended', function () {
      _this.showNext();
    })

    videoEle.addEventListener('canplaythrough', function () {
      console.log('canplaythrough');
      console.log(videoEle.duration);
    })

    this._initAllMusic();
    setTimeout(() => {
      this.audioPlay();
    }, 800)
  }
}
</script>

<style lang="less" scoped>
@import url('./po.less');

.pageOne {
  height: 100%;
  .music {
    position: absolute;
    right: .5rem;
    top: .5rem;
    z-index: 3;
    margin-left: 1rem;
    margin-bottom: 1rem;
    width: 2.75rem /* 44/16 */;
    height: 2.25rem /* 36/16 */;
    .cloud {
      .note {
        width: 2.1875rem /* 35/16 */;
        height: 2.1875rem /* 35/16 */;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .on {
        background-image: url('./music-on.png');
      }
      .off {
        background-image: url('./music-off.png');
      }
      .rotating {
        animation: rotate-music 2s linear infinite;
      }
    }
  }

  .myVideo {
    width: 23.4375rem /* 375/16 */;
  }
  .md1 {
    position: absolute;
    top: 34%;
    margin-left: 5.75rem /* 92/16 */;
    width: 11.4375rem /* 183/16 */;
    height: 6.0625rem /* 97/16 */;
    background-image: url('./s1-desc1.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
  .md2 {
    position: absolute;
    top: 34%;
    left: 50%;
    margin-left: -8.0625rem /* 129/16 */;
    width: 16.125rem /* 258/16 */;
    height: 4.6875rem /* 75/16 */;
    background-image: url('./s1-desc2.png');
    background-repeat: no-repeat;
    background-size: cover;
  }
  .btn-main {
    position: absolute;
    bottom: 6%;
    left: 50%;
    margin-left: -5.875rem /* 94/16 */;
    width: 11.6875rem /* 187/16 */;
    height: 4.5625rem /* 73/16 */;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('./s1-btn.png');
  }
  .vd-btn-group {
    position: absolute;
    display: flex;
    bottom: 6%;
    .vd-btn {
      width: 11.6875rem /* 187/16 */;
      height: 4.5625rem /* 73/16 */;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}

@keyframes rotate-music {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.slideIn {
  animation: slideIn .4s linear;
}

@keyframes slideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
